export default __webpack_public_path__ + "static/media/office-1.f9e4a1a0.webp";